<template>
  <div class="col-12">
    <div class="card card-outline card-info">
      <div class="card-header">
        <h3 class="card-title">Evaluaciones</h3>
      </div>
      <div class="card-body w-full">
        <div class="tabs">
          <button @click="activeTab = 'misEvaluaciones'" :class="{ active: activeTab === 'misEvaluaciones' }"  v-if="thisEvaluations.length > 0">Mis Evaluaciones</button>
          <button @click="activeTab = 'evaluacionesAsignadas'" :class="{ active: activeTab === 'evaluacionesAsignadas' }"  v-if="thisAssignedEvaluations.length > 0">Evaluaciones Asignadas</button>
          <button @click="activeTab = 'planesIndividuales'" :class="{ active: activeTab === 'planesIndividuales' }"  v-if="thisEvaluations.length > 0">Planes Individuales</button>
        </div>
        <div v-if="thisEvaluations.length == 0 && thisAssignedEvaluations.length == 0 && thisPlansIndividuals.length == 0">
          <p>No hay evaluaciones para mostrar.</p>
        </div>
        
        <div v-if="activeTab === 'misEvaluaciones'">
          <div v-for="(user, row) in thisEvaluations" :key="row">
            <hr>
            <h5><b>{{ user.name }} {{ user.last_name }} - {{ user.organization_chart.profile.name }}</b></h5> 
          <hr>
          <h5>Evaluación general de competencias</h5>
            <div style="width: 100%;">
              <div v-for="(evaluation, index) in user.completed_evaluations" :key="index" style="display: inline;">
                <button class="bg-blue-500 px-4 py-2 rounded btn-default text-black ml-2" v-if="evaluation.evaluatable_type == 'App\\Models\\Evaluation' || evaluation.evaluatable_type == 'App\Models\Evaluation'" @click="openFilledModal(evaluation.id)">
                  <i class="fas fa-check-circle"></i> {{ evaluation.completed_at }}
                </button>
              </div>
              <router-link :to="{ name: 'evaluation-fill', params: { user: user , evaluation: user.organization_chart.profile.evaluations[0] } }" 
                class="evaluation-link flex items-center"  v-if="user.completed_evaluations.length  == 0">
                <button class="btn-success px-4 py-2 rounded btn-default text-white ml-2">Evaluar a consultor</button>
              </router-link>
              <button class="bg-blue-500 px-4 py-2 rounded btn-default text-black ml-2 relative"  style="position: relative;" 
                @click="openModal(user.organization_chart.profile.evaluations[0].id, user.id)">
                <i class="fas fa-user-cog"></i>
                <span class="counter-users" v-if="user.target_evaluations.length > 0 "> {{ user.target_evaluations.length }}</span>
              </button>
            </div>
            <hr>
            <h5>Evaluación de cumplimiento</h5>
            <div v-if="user.scope_evaluations.length == 0" style="width: 100%;">
              <router-link :to="{ name: 'manager-goals', params: { user: user } }" class="evaluation-link flex items-center">
                <button class="bg-blue-500 px-4 py-2 rounded btn-default">+ Evaluación de objetivos</button>
              </router-link>
            </div>
            <div style="width: 100%;" v-else>
              <div v-for="(evaluation, index) in user.completed_evaluations" :key="index" style="display: inline;">
                <button class="bg-blue-500 px-4 py-2 rounded btn-default text-black ml-2" v-if="evaluation.evaluatable_type == 'App\\Models\\ScopeEvaluation'"  @click="openFilledModal(evaluation.id)">
                <i class="fas fa-check-circle"></i> {{ evaluation.completed_at }}
                </button>
              </div>
              <router-link :to="{ name: 'evaluation-fill-scope', params: { user: user , evaluation: user.scope_evaluations[0] } }" class="evaluation-link flex items-center">
                <button class="btn-success px-4 py-2 rounded btn-default text-white ml-2">+ Calificar Evaluación de objetivos</button>
              </router-link>				
            </div>
          </div>
        </div>
        
        <div v-if="activeTab === 'evaluacionesAsignadas'">
           <div v-for="(user, row) in thisAssignedEvaluations" :key="row">
            <hr>
            <h5><b>{{ user.name }} {{ user.last_name }} - {{ user.organization_chart.profile.name }}</b></h5>
            <h7>Evaluación general de competencias</h7>
            <div style="width: 100%;">
            <div v-for="(evaluation, index) in user.completed_evaluations" :key="index" style="display: inline;">
              <button class="bg-blue-500 px-4 py-2 rounded btn-default text-black ml-2" v-if="evaluation.evaluatable_type == 'App\\Models\\Evaluation'" @click="openFilledModal(evaluation.id)">
                <i class="fas fa-check-circle"></i> {{ evaluation.completed_at }}
              </button>
            </div>
            <router-link :to="{ name: 'evaluation-fill', params: { user: user , evaluation: user.organization_chart.profile.evaluations[0] } }" 
            class="evaluation-link flex items-center" v-if="user.completed_evaluations.length  == 0">
              <button class="btn-success px-4 py-2 rounded btn-default text-white ml-2">Evaluar a consultor</button>
            </router-link>
            </div>
            <hr>
          </div>
        </div>
        
        <div v-if="activeTab === 'planesIndividuales'">
          <div v-for="(user, row) in thisPlansIndividuals" :key="row">
            <hr>
            <h5><b>{{ user.name }} {{ user.last_name }} - {{ user.organization_chart.profile.name }}</b></h5>
            <div style="width: 100%;">
              <div v-for="(evaluation, index) in user.completed_evaluations" :key="index" style="display: inline;">
                <button class="bg-blue-500 px-4 py-2 rounded btn-default text-black ml-2" v-if="evaluation.evaluatable_type === 'App\\Models\\IndividualPlan'" @click="openFilledModal(evaluation.id)">
                  <i class="fas fa-check-circle"></i> {{ evaluation.completed_at }}
                </button>
              </div>
              <router-link :to="{ name: 'plan-fill', params: { id: user.individual_plan[0].id } }" class="evaluation-link flex items-center" v-if="user.individual_plan.length > 0 && !hasEvaluationThisMonth(user)">
                <button class="btn-default px-4 py-2 rounded  btn-default text-black ml-2">Agregar seguimiento del plan</button>
              </router-link>
              <button class="btn-success px-4 py-2 rounded  btn-default text-white ml-2" @click="openPlanModal(user.organization_chart.profile.evaluations[0].id, user.id)" v-if="user.individual_plan.length == 0">Agregar plan individual de mejora</button>
              <span class="text-gray-500 text-sm ml-2" v-if="hasEvaluationThisMonth(user)"> Seguimiento mensual completado  <i class="fas fa-check-circle"></i> </span>
            </div>
            <hr>
          </div>
        </div>

        <UserAssignmentModal
          :evaluationId="currentEvaluationId"
          :toUserId="currentUserId"
          :isOpen="isModalOpen"
          @close="closeModal"
          @save="evaluationsRequest()"
        />
        <IndividualPlanModal
			:isModalOpen="isModalPlanOpen"
			:evaluationId="currentEvaluationId"
			:userId="userId"
			@close="closePlanModal"
			@plan-saved="individualPlanRequest()"
				/>
        <FilledEvaluation
        :isModalOpen="isModalFilledOpen"
        :evaluationId="currentFilledEvaluationId"
        :userId="userId"
        @closeFilled="isModalFilledOpen = false;evaluationsRequest()"
				/>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import request from '../../services/request';
import UserAssignmentModal from "../../component/evaluations/AddEvaluationUser.vue";
import IndividualPlanModal from "../../component/evaluations/IndividualPlanModal.vue";
import FilledEvaluation from "../../component/evaluations/FilledEvaluation.vue";


export default {
  name: "manager-evaluations",
  components: { UserAssignmentModal,IndividualPlanModal, FilledEvaluation },
  data() {
    return {
		evaluations: [],
		assignedEvaluations: [],
		evaluationsIndividualPlan: [],
		isModalPlanOpen: false,
		isModalFilledOpen: false,
		currentEvaluationId: 0,
		currentFilledEvaluationId: 0,
		isModalOpen: false,
		currentUserId: 0,
		userId : 0,
		activeTab: 'misEvaluaciones'
    };
  },
  async mounted() {
    this.setHeaderTitle('Auto Evaluación');
    await this.evaluationsRequest();
    await this.assignedEvaluationsRequest();
    await this.individualPlanRequest();
  },
  computed: {
    thisEvaluations() {
      return this.evaluations?.data || [];
	},
	thisAssignedEvaluations() {
		return this.assignedEvaluations?.data || [];
	},
	thisPlansIndividuals() {
		return this.evaluationsIndividualPlan?.data || [];
	},
  },
  methods: {
    async evaluationsRequest() {
      try {
        const { data } = await request.list('/my-evaluations');
        if (data) this.evaluations = data;
      } catch (error) {
        console.log(error);
		}
    },	
  openFilledModal(evaluationId) { 
    this.currentFilledEvaluationId = evaluationId;
    this.isModalFilledOpen = true;
  },
    openPlanModal(evaluationId, userId) { 
      this.currentEvaluationId = evaluationId;
      this.userId = userId;
      this.isModalPlanOpen = true;
	},
	closePlanModal() {
		this.isModalPlanOpen = false;
	},
    async assignedEvaluationsRequest() {
      try {
        const { data } = await request.list('/assigned-evaluations');
        if (data) this.assignedEvaluations = data;
        if (this.thisEvaluations.length === 0) {
            this.activeTab = 'evaluacionesAsignadas'
        } 
      } catch (error) {
        console.log(error);
      }
    },
    async individualPlanRequest() {
      try {
        const { data } = await request.list('/individual-plan');
        if (data) this.evaluationsIndividualPlan = data;
         if (this.thisAssignedEvaluations.length === 0 && this.thisEvaluations.length === 0) {
            this.activeTab = 'planesIndividuales';
        } 
      } catch (error) {
        console.log(error);
      }
    },
    openModal(evaluationId, userId) {
      this.currentEvaluationId = parseInt(evaluationId, 10);
      this.currentUserId = parseInt(userId, 10);
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
	},
	hasEvaluationThisMonth(user) {
        const currentMonth = new Date().getMonth() + 1; // Mes actual (0-indexed, por eso sumamos 1)
        const currentYear = new Date().getFullYear(); // Año actual

        return user.completed_evaluations.some(evaluation => {
            if (evaluation.evaluatable_type === 'App\\Models\\IndividualPlan' && evaluation.completed_at) {
                const evalDate = new Date(evaluation.completed_at);
                return evalDate.getMonth() + 1 === currentMonth && evalDate.getFullYear() === currentYear;
            }
            return false;
        });
    },
    ...mapMutations({ setHeaderTitle: 'setHeaderTitle' }),
    ...mapActions({ errorNotification: 'alert/error' })
  }
};
</script>

<style scoped>
.tabs {
  display: flex;
  margin-bottom: 15px;
}
.tabs button {
  flex: 1;
  padding: 10px;
  cursor: pointer;
  border: none;
  background: #f1f1f1;
}
.tabs button.active {
  background: #1d4745;
  color: white;
}
.hidden {
  display: none;
}

.counter-users {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #14534f;
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 50%;
}
</style>
